/**
 * oauth2.js provides a way to bootstrap the requirements for the OAuth 2
 * library before loading the application, for example, waiting for successful
 * IBD Datastore creation, grabbing of tokens pushed into local storage from
 * native apps e.t.c.
 *
 */
import { setupOAuth } from '../utils/oauth2';

/**
 * via https://github.com/jakearchibald/safari-14-idb-fix/blob/main/src/index.ts
 * refer: https://bugs.webkit.org/show_bug.cgi?id=226547
 *
 * Safari has a horrible bug where IDB requests can hang while the browser is starting up.
 * The only solution is to keep nudging it until it's awake.
 * This probably creates garbage, but garbage is better than totally failing.
 */
function idbReady() {
  const isSafari =
    !navigator.userAgentData &&
    /(AppleWebKit|Safari)\//.test(navigator.userAgent) &&
    !/Chrom(e|ium)\//.test(navigator.userAgent);

  // No point putting other browsers or older versions of Safari through this mess.
  if (!isSafari || !indexedDB.databases) return Promise.resolve();

  let intervalId;
  return new Promise((resolve) => {
    const tryIdb = () => indexedDB.databases().finally(resolve);
    intervalId = setInterval(tryIdb, 100);
    tryIdb();
  }).finally(() => {
    clearInterval(intervalId);
  });
}

export function initialize(application) {
  application.deferReadiness();

  // Setup required OAuth configuration, then load ember!
  idbReady()
    .then(() => setupOAuth())
    .then(() => {
      application.advanceReadiness();
    });
}

export default {
  name: 'oauth2',
  initialize: initialize,
};
